// extracted by mini-css-extract-plugin
export default {"root":"ButtonWithDescription__root brandColor__link","button":"ButtonWithDescription__button","description":"ButtonWithDescription__description"};